<template>
  <div>
    <div class="text-left mb-5">
      <span class="headline" id="headerlist">Report viewer</span>
    </div>
    <v-row justify="start" align="start">
      <v-chip
        class="mx-2"
        filter
        :input-value="chipReport == 'sale'"
        @click="setChipReport('sale')"
      >
        Sales
      </v-chip>
      <v-chip
        class="mx-2"
        filter
        :input-value="chipReport == 'inventory'"
        @click="setChipReport('inventory')"
      >
        Inventory
      </v-chip>
    </v-row>
    <Sale v-if="chipReport == 'sale'" />
    <Inventory v-if="chipReport == 'inventory'" />
  </div>
</template>

<script>
import Sale from './Sale';
import Inventory from './Inventory';

export default {
  components: {
    Sale,
    Inventory
  },
  data: function() {
    return {
      chipReport: 'sale'
    };
  },
  methods: {
    setChipReport(report) {
      this.chipReport = report;
    }
  }
};
</script>
